const MachineActions = {
    MACHINE_FETCHED: "MACHINE_FETCHED",
    MACHINE_SAVED: "MACHINE_SAVED",
    MACHINE_CLEARED: "MACHINE_CLEARED",
};

export interface InfrastructureAreaState {
    currentMachine: MachineState;
}

export interface MachineState {
    id: string;
    name: string;
    machineIconFilename: string;
    isDisabled: boolean;
}

export function machineFetched(state: MachineState) {
    return { type: MachineActions.MACHINE_FETCHED, state};
}

export function machineSaved(newState: MachineState) {
    return { type: MachineActions.MACHINE_SAVED, state: newState};
}

export function machineCleared() {
    return { type: MachineActions.MACHINE_CLEARED};
}

const infrastructureArea = (state: InfrastructureAreaState = {currentMachine: null}, action: any): InfrastructureAreaState => {
    switch (action.type) {
        case MachineActions.MACHINE_SAVED:
        case MachineActions.MACHINE_FETCHED:
            const machine = action.state as MachineState;
            return {
                currentMachine: {
                    id: machine.id,
                    name: machine.name,
                    machineIconFilename: machine.machineIconFilename,
                    isDisabled: machine.isDisabled,
                }
            };
        case MachineActions.MACHINE_CLEARED:
            return {
                currentMachine: null
            };
        default:
            return state;
    }
};

export default infrastructureArea;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/infrastructure/reducers/infrastructureArea.ts